import { render, staticRenderFns } from "./ItemStats.vue?vue&type=template&id=4fa2ac58&scoped=true&"
import script from "./ItemStats.vue?vue&type=script&lang=ts&"
export * from "./ItemStats.vue?vue&type=script&lang=ts&"
import style0 from "./ItemStats.vue?vue&type=style&index=0&id=4fa2ac58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2ac58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VRadio,VRadioGroup})
